export default __webpack_public_path__ + "static/media/02-small.f005bf22.jpg";